<template>
  <form-field
    :id="id"
    :title="title"
    :error-message="errorMessage"
    :block-label="false"
    :mandatory="mandatory"
    :show-label="showLabel"
  >
    <template #info>
      <slot name="info" />
    </template>
    <form-radio-button
      v-for="opt in options"
      :id="`${id}_${opt.value}`"
      :key="opt.value"
      :title="opt.name"
      :disabled="disabled"
      :class="{ horizontal: displayHorizontally }"
    >
      <input
        :id="`${id}_${opt.value}`"
        v-model="selectedOption"
        :value="opt.value"
        :name="`options_${id}`"
        :data-qa="dataQa"
        :disabled="disabled"
        type="radio"
        @change="$emit('change', $event.target.value)"
      />
    </form-radio-button>
    <slot />
  </form-field>
</template>

<script>
import FormField from '@/components/generic/presentational/atoms/formField/FormField.vue'
import FormRadioButton from '@/components/generic/presentational/atoms/formRadioButton/FormRadioButton.vue'

export default {
  components: {
    FormField,
    FormRadioButton,
  },
  props: {
    options: {
      type: Array,
      required: true,
    },
    displayHorizontally: {
      type: Boolean,
      default: false,
    },
    id: {
      type: String,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      required: true,
    },
    errorMessage: {
      type: String,
      default: '',
    },
    mandatory: {
      type: Boolean,
      default: false,
    },
    showLabel: {
      type: Boolean,
      default: true,
    },
    modelValue: {
      type: [String, Number, Boolean],
      default: null,
    },
    dataQa: {
      type: String,
      default: null,
    },
  },
  emits: ['change'],
  data() {
    return {
      selectedOption: null,
    }
  },
  created() {
    this.selectedOption =
      this.modelValue || (this.options.find((x) => x.default) || this.options[0])?.value
  },
}
</script>

<style lang="scss" scoped>
:deep() {
  .radio-button {
    display: block;
    margin-top: 0;
    margin-left: 0;
    margin-right: 0;
    margin-bottom: 0.5rem;
  }
  .horizontal {
    display: inline-block;
  }
}
</style>
